/** Coerce all values in a record to numbers (handles PostgreSQL string numerics). */
export function numericRecord(obj: Record<string, unknown>): Record<string, number> {
    const result: Record<string, number> = {};
    for (const [k, v] of Object.entries(obj)) {
        result[k] = Number(v);
    }
    return result;
}
